import React, { useRef } from "react";
import clsx from "clsx";
import { Dialog, DialogActions, DialogContent, Grid } from "@mui/material";
import { TextField, Button, Form, Typography, Stack } from "@curves/ui-base";
import GradientColorHeader from "@icoach/components/dialog/GradientColorHeader";
import { useMemberProfileApi } from "@apis/useMemberProfileApi";
import { isFunction, refIsRequiredError } from "@util/utils";
import { MEMBER_NOTE_TYPE } from "@icoach/constants";

/**
 * 重要註解：
 * - `xFactorNotes` 是一個陣列。
 * - `xFactorNotes[0]` 表示「動機與目的」，`xFactorNotes[1]` 表示「運動目標」。
 * - 注意：這是上線後新增的需求，團隊決定不改變既有資料結構（xFactorNotes 保持陣列格式），
 *   因此透過索引 [0] 和 [1] 固定對應動機與目的、運動目標。後續維護時需留意此約定。
 */
const XFactorDialog = React.forwardRef((props, ref) => {
	const { className, open, sourceData = [], onClose, refresh } = props;
	if (!open) return null;
	const { xFactorNotes: xFactorNotesProps = [], memberID } = sourceData || {};
	const { postMemberProfileNotesApi } = useMemberProfileApi();

	const xFactorNotes = xFactorNotesProps || [];

	const xFactorRef = useRef(null);
	const fitnessGoalRef = useRef(null);

	const doMemberProfileNotesApi = async (memberID, params) => {
		let resp = await postMemberProfileNotesApi(memberID, params);
		if (resp) {
			const { noteItems } = resp;
			isFunction(refresh) && refresh(noteItems);
			isFunction(onClose) && onClose();
		}
	};

	const getParams = () => {
		return {
			noteType: MEMBER_NOTE_TYPE.XFACTOR,
			noteItems: [xFactorRef.current && xFactorRef.current.getResult(), fitnessGoalRef.current && fitnessGoalRef.current.getResult()],
		};
	};

	const handleSubmit = () => {
		let isError = refIsRequiredError(xFactorRef, fitnessGoalRef);
		if (!isError) {
			let params = getParams();
			doMemberProfileNotesApi(memberID, params);
		}
	};
	return (
		<Dialog className={clsx("simple-content", "dialog", className)} PaperProps={{ className: "wx-65rem", component: Form }} onSubmit={handleSubmit} open={open} fullWidth>
			<GradientColorHeader onClose={onClose}>X-Factor 與運動目標</GradientColorHeader>
			<DialogContent>
				<Grid container spacing={2}>
					<Grid xs={3} item>
						<Stack className={"h-100"} justifyContent={"end"} alignItems={"center"}>
							<Typography className={"text-right mb-0"}>動機與目的</Typography>
						</Stack>
					</Grid>
					<Grid xs={9} item>
						<TextField ref={xFactorRef} key={xFactorNotes[0]} defaultValue={xFactorNotes[0]} fullWidth />
					</Grid>
					<Grid xs={3} item>
						<Stack className={"h-100"} justifyContent={"end"} alignItems={"center"}>
							<Typography className={"text-right mb-0"}>運動目標</Typography>
						</Stack>
					</Grid>
					<Grid xs={9} item>
						<TextField ref={fitnessGoalRef} key={xFactorNotes[1]} defaultValue={xFactorNotes[1]} fullWidth />
					</Grid>
				</Grid>
			</DialogContent>
			<DialogActions>
				<Button type={"submit"} variant="contained">
					確認送出
				</Button>
			</DialogActions>
		</Dialog>
	);
});

export default XFactorDialog;
